import API from './API.js'

export default class Countries extends API {
  constructor() {
    super('countries')
  }
}
